import React, { Component } from 'react';
import { connect } from 'react-redux';

import Layout from '../../components/layout';
import Loading from '../../components/spinner';
import { NormalText, SmallText, Spacer, StrongText, Title } from '../../components/common';
import { withTranslation } from '../../lib/translate';

import './index.css';
import { forwardTo, isWebConfig } from '../../lib/utils';
import { QRCodeCanvas } from 'qrcode.react';
import Basket from '../../lib/basket';
import { IonCol, IonRow } from '@ionic/react';
import moment from 'moment';

class GiftCard extends Component {
    componentDidMount() {
        if (!this.props.location?.state?.card) {
            forwardTo('/loyalty')
        }
    }

    render() {
        const { __ } = this.props;
        const card = this.props.location?.state?.card
        const isExpired = this.props.location?.state?.isExpired
        return (
            <Loading>
                <Layout headerWithTitle color="transparent" title={__('Gift card')}>
                    <div className='absolute-content scrollable-y'>
                        <Title className='web-only'>{__('Gift card')}</Title>
                        <div className='box-content gift-card-container'>
                            <div>
                                <div style={{ top: 'var(--ion-padding)', position: 'absolute' }}>
                                    <SmallText>{__('Remaining balance')}</SmallText>
                                    <StrongText>{Basket.formatPrice(card?.value_remaining / 100, true)}</StrongText>
                                </div>

                                <div style={{ bottom: 'var(--ion-padding)', position: 'absolute' }}>
                                    <SmallText>{__('Consumer ID')}</SmallText>
                                    <StrongText>{card?.consumer_id}</StrongText>
                                </div>

                            </div>
                            <div>
                                <QRCodeCanvas value={card?.qr_code} size={isWebConfig() ? 126 : 110} />


                            </div>
                        </div>
                        <Spacer size={2} />
                        <IonRow>
                            <IonCol>
                                <SmallText>{`${__('Gift card reference')}: ${card?.ikentoo_id}`}</SmallText>
                            </IonCol>
                            <IonCol style={{alignSelf:'flex-start'}} className='righted'>
                                <SmallText className={`${isExpired?'danger-color':""}`}>{`${isExpired ? __('Expired:') : __('Expires:')} ${card?.expiry_date}`}</SmallText>
                            </IonCol>

                        </IonRow>
                        <Spacer size={5} />
                        {card?.history.length > 0 &&
                            <>

                                <Title>
                                    {__('History')}
                                </Title>
                                <div className="transactions-wrapper box-wrapper">
                                    {card.history.map(el => (
                                        <div>

                                            <IonRow>
                                                <IonCol>
                                                    <StrongText>{el.type == 'value_added' ? __('Value added') : __('Value spent')}</StrongText>
                                                    <Spacer size={0} />
                                                    <SmallText>{moment(el.timestamp).format('DD MMM YYYY h:mm a')}</SmallText>
                                                </IonCol>
                                                <IonCol className='righted' style={{ alignSelf: 'center' }}>
                                                    <NormalText className={`${el.type == 'value_added' ? 'success-color' : 'danger-color'}`}>
                                                        {`${el.type == 'value_added' ? '+' : '-'}${Basket.formatPrice(el.value / 100, true)}`}
                                                    </NormalText>
                                                </IonCol>

                                            </IonRow>
                                        </div>

                                    ))}
                                </div>
                            </>

                        }

                    </div>
                </Layout>
            </Loading>
        );
    }
}

const stateToProps = (state) => {
    return {
    };
};

export default connect(stateToProps)(withTranslation(GiftCard));
